import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setSidebarOpen } from '../../redux/slices/uiSlice';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import styles from './Layout.module.css';

const isDesktopWidth = () => window.innerWidth > 1024;

const Layout = () => {
  const dispatch = useDispatch();
  const { sidebarOpen } = useSelector(state => state.ui);
  const { selectedMosadCode } = useSelector(state => state.user);
  const wasDesktop = useRef(isDesktopWidth());

  useEffect(() => {
    // Initialize sidebar state based on screen size
    dispatch(setSidebarOpen(isDesktopWidth()));
  }, [dispatch]); // Run only once on mount

  useEffect(() => {
    // Only react when the viewport actually crosses the desktop/mobile
    // breakpoint, not on every 'resize' event (mobile browsers fire these
    // constantly, e.g. address bar show/hide, which would otherwise fight
    // a user who just opened/closed the drawer by hand).
    const handleResize = () => {
      const isDesktop = isDesktopWidth();
      if (isDesktop === wasDesktop.current) return;
      wasDesktop.current = isDesktop;
      dispatch(setSidebarOpen(isDesktop));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  useEffect(() => {
    // Prevent the page behind the drawer from scrolling on mobile.
    if (!isDesktopWidth()) {
      document.body.style.overflow = sidebarOpen ? 'hidden' : '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  return (
    <div className={styles.layout}>
      <Sidebar selectedMosadCode={selectedMosadCode} />
      <div className={`${styles.content} ${sidebarOpen ? styles.contentWithSidebar : ''}`}>
        <Navbar selectedMosadCode={selectedMosadCode} />
        <main className={styles.main}>
          <Outlet context={{ selectedMosadCode }} />
        </main>
      </div>
    </div>
  );
};

export default Layout; 